<video #builderVideo (canplay)="playVideo()" muted width="100%"
       poster="{{videoPoster}}">

  <source src="{{videoSrc}}"
          type="video/mp4">
</video>
